module.exports = __webpack_public_path__ + "img/price.212fb53e.svg";